import Space from 'antd/lib/space';
import Tooltip from 'antd/lib/tooltip';
import * as React from 'react';
import { AppStoreBuild } from '../../types';
import { AppBuildComponent, CIBuildComponent } from '../BuildComponents';
import { buildContainerStyle } from '../styles/globalStyles';
import LinkageIcon from '../icons/LinkageIcon';
import Text from 'antd/lib/typography/Text';
import { DatetimeFormat } from '../../timeHelpers';
import { dayjs } from '@/extendedDayjs';

interface AppStoreBuildComponentProps extends AppStoreBuild {
    label?: string;
    styleOverrides?: React.CSSProperties;
}

export const AppStoreBuildComponent: React.FC<AppStoreBuildComponentProps> = (props: AppStoreBuildComponentProps) => {
    const { appStoreBuild, associatedCIBuild, label, styleOverrides } = props;

    let appStoreBuildComponent = null;
    let appStoreCIBuildComponent = null;

    if (appStoreBuild) {
        const dateFormat = DatetimeFormat.ShortMonthDateTime;
        const uploadedOn = dayjs(appStoreBuild.uploadedAt).format(dateFormat);
        appStoreBuildComponent = (
            <Tooltip title={`Uploaded on ${uploadedOn}`}>
                <div>
                    <AppBuildComponent
                        integrationId={appStoreBuild.integrationId}
                        buildIdentifier={appStoreBuild.buildNumber}
                        isProcessed={appStoreBuild.isProcessed}
                        strong
                    />
                </div>
            </Tooltip>
        );
    }

    if (associatedCIBuild) {
        appStoreCIBuildComponent = (
            <Tooltip title={associatedCIBuild.commitMessage}>
                <div>
                    <CIBuildComponent
                        integrationId={associatedCIBuild.integrationId}
                        buildIdentifier={associatedCIBuild.buildIdentifier}
                        strong
                    />
                </div>
            </Tooltip>
        );
    }

    return (
        <Space style={{ ...buildContainerStyle, flexShrink: 0, ...styleOverrides }} wrap={false}>
            {label && <Text style={{ marginRight: '6px' }}>{label}</Text>}
            {appStoreBuildComponent}
            {appStoreBuild && associatedCIBuild && <LinkageIcon width={16} height={16} />}
            {appStoreCIBuildComponent}
        </Space>
    );
};

export default AppStoreBuildComponent;
